// store/modules/auth/index.js
import { apiClient } from '@/api'
import { useCookies } from 'vue3-cookies'
import { ElMessage } from 'element-plus'

const cookies = useCookies(['token']);
export default {
  namespaced: true,
  state: () => ({
    user: {
      id: null,
      name: null,
      email: null,
      avatar: '',
      permissions: [], // список прав
      locations: [], // список доступных локаций/объектов
      timezone: 'Europe/Moscow',
      cell_interval: 15,
      subscription: {
        days_left:8,
        status:"active"
      }
    },
    is_admin: false,
    is_login: false
  }),
  getters:{
    isNewUser: state => state.user.is_new_user,
    isLogin: state => state.is_login,
    userName: state => state.user.name,
    avaString: state => state.user.avatar,
    userMail: state => state.user.email,
    userID: state => state.user.id,
    cellInterval: state => state.user.cell_interval,
  },
  actions: {
    async registrationAdmin(_, form) {
      const res = await apiClient('registration.admin', form)
      if (res?.success) {
        ElMessage.success(res?.message);
      }
    },
    revokeUser({ commit }) {
      commit('REVOKE_TOKEN')
      cookies.cookies.remove('token')
    },
    async checkLogin({ commit, dispatch }, option) {
      const res = await apiClient('check.login', option);
      if (res?.success && res?.token) {
        commit('SET_TOKEN', res.token)
        // сразу после установки токена подтягиваем профиль пользователя
        await dispatch('getUserInfo')
        // флаг "вошёл" включаем только после успешной загрузки профиля
        await Promise.all([
          dispatch('roles/fetchRoles', null, { root: true }),
          dispatch('messengers/fetchDialogs', null, { root: true }),
          // при необходимости:
          dispatch('messengers/fetchActiveMessengers', null, { root: true }),
        ])
        commit('IS_LOGIN', true)
      }
      return res;
    },
    async getUserInfo({ commit }) {
      const res = await apiClient('user.info')
      if (res?.user) {
        if (res?.user?.id) {
          commit('SET_USER', res?.user);
        } else {
          commit('SET_TOKEN', false)
          cookies.cookies.remove('token')
        }
      } else {
        commit('SET_TOKEN', false)
        cookies.cookies.remove('token')
      }
    },
    setIsLogin({ commit }, payload) {
      commit('IS_LOGIN', payload)
    },

    async checkEmail(_, email) {
      const res = await apiClient('registration.checkEmail', { email })
      return res?.exists || false
    },

    async registerAccount({ commit, dispatch }, form) {
      const res = await apiClient('registration.account', form)
      if (res?.success && res?.token) {
        commit('SET_TOKEN', res.token)
        await dispatch('getUserInfo')
        await Promise.all([
          dispatch('roles/fetchRoles', null, { root: true }),
          dispatch('messengers/fetchDialogs', null, { root: true }),
        ])
        commit('IS_LOGIN', true)
      } else if (res?.message) {
        ElMessage.error(res.message)
      }
      return res
    },
    async requestPasswordReset(_, payload) {
      const res = await apiClient('auth.requestReset', payload)
      if (res?.success) {
        ElMessage.success('Письмо отправлено, проверьте почту')
      } else {
        ElMessage.error(res?.message || 'Ошибка запроса')
      }
      return res
    },
    async resetPassword(_, payload) {
      return await apiClient('auth.resetPassword', payload)
    },
  },
  mutations: {
    SET_TOKEN(state, data) {
      cookies.cookies.set('token', data, '7d')
    },
    SET_USER(state, data) {
      state.user = {
        id: data.id ?? null,
        name: data.name ?? null,
        email: data.email ?? null,
        avatar: data.avatar ?? '',
        permissions: data.role?.permissions ?? [],
        locations: data.locations ?? [],
        timezone: data.timezone ?? 'Europe/Moscow',
        cell_interval: data.cell_interval ?? 15,
        is_new_user: data.is_new_user ?? false,
        is_admin: data.is_admin ?? false,
        subscription: data.subscription ?? null,
      };
    },
    REVOKE_TOKEN(state) {
      state.user = { id: null, name: null, email: null, avatar: '', permissions: [], locations: [], timezone: 'Europe/Moscow', cell_interval: 15 }
      state.is_login = false
      cookies.cookies.remove('token')
    },
    IS_LOGIN(state, bool){
      state.is_login = bool;
    }
  }
}
